/**
 * @define Expandable
 * Expandable component for displaying multiple expandable items.
 *
 */
// Vendor
import React from "react";
import classNames from "classnames"; // Local

import getClassNameFactory from "../../../../utilities/classNames";
import Item from "../Item";

var List = function List(_ref) {
  var children = _ref.children,
      ordered = _ref.ordered,
      listItemIdConfig = _ref.listItemIdConfig;
  var getClassName = getClassNameFactory(List.displayName);
  var ListElement = ordered ? "ol" : "ul";
  return /*#__PURE__*/React.createElement(ListElement, {
    className: getClassName({
      modifiers: classNames({
        ordered: ordered
      })
    })
  }, React.Children.map(children, function (child, index) {
    return child.type === Item && /*#__PURE__*/React.createElement("li", {
      className: getClassName({
        descendantName: "itemContainer"
      }),
      id: listItemIdConfig && (listItemIdConfig.isCountable ? listItemIdConfig.idLabel + (index + 1) : listItemIdConfig.idLabel)
    }, ordered && /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "itemNumber"
      })
    }, index + 1), child);
  }));
};

List.displayName = "Expandable.List";
export default List;